import React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';

export default () => <Icon icon="bkCrown" color="icon-default" width="42px" />;
